// extracted by mini-css-extract-plugin
module.exports = {"list":"MobileMetaMenu_list__m2M3Z","link":"MobileMetaMenu_link__Wk_TU"};